var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-loading",class:{'is-loading': _vm.commonLoading}},[_c('van-loading',{attrs:{"color":_vm.color,"size":"44px","vertical":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }